import { useTranslation } from 'react-i18next';
import { Source } from '../Source';
import { Formula } from './Formula';
import type { Block } from '../../types';

export function MathBlock({ block }: { block: Block }) {
  const { t } = useTranslation();
  const math = block.math;
  if (!math) return null;

  return (
    <figure className="fig" data-od-id="formula">
      <div className="fig-body">
        <div className="formula">
          <Formula markup={t(math.exprKey)} />
          <div className="concepts">
            <div className="concept">
              <span className="k">{t('readTitle')}</span>
              <span className="v">{t(math.readKey)}</span>
            </div>
            <div className="concept">
              <span className="k">{t('useTitle')}</span>
              <span className="v">{t(math.useKey)}</span>
            </div>
          </div>
        </div>
      </div>
      {(math.ref || math.ref2) && (
        <figcaption className="fig-foot">
          {math.ref && <Source refKey={math.ref} />}
          {math.ref2 && <Source refKey={math.ref2} />}
        </figcaption>
      )}
    </figure>
  );
}
